var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',_vm._l((_vm.links),function(link){return _c('a',{staticClass:"btn-link",attrs:{"href":_vm.getLink(link.link),"target":_vm.getTarget(link.link)}},[_c('span',{staticClass:"link small"},[_c('img',{attrs:{"src":_vm.platformImage(link.platform),"alt":`Finde Caroline Stäger auf ${link.platform}`}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }